import { render, staticRenderFns } from "./RIOutwardsReports.vue?vue&type=template&id=07f1d6e4&"
import script from "./RIOutwardsReports.vue?vue&type=script&lang=js&"
export * from "./RIOutwardsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports